<app-sharepoint-table #userGrid *ngIf="this.tableConfigUsers" class="users-table" [configuration]="this.tableConfigUsers"
  (onTooolbarButtonClick)="onTooolbarButtonClick($event)">
</app-sharepoint-table>
